import React from 'react';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { Textarea } from './ui/textarea';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';

/**
 * Contact information fields for the HOME registration form.
 * Full Name, NRIC, Mobile, Email, Installation Address, Postcode, Preferred Installation Day.
 */
export const HomeContactFields = ({ formData, fieldErrors, handleInputChange, validateField }) => {
  const err = (k) => fieldErrors[k] ? 'border-red-500 focus-visible:ring-red-500' : '';
  return (
    <>
      <div className="space-y-2">
        <Label htmlFor="name">Full Name <span className="text-red-500">*</span></Label>
        <Input id="name" value={formData.name} onChange={(e) => handleInputChange('name', e.target.value)} placeholder="Enter your full name"
          aria-invalid={!!fieldErrors.name} className={err('name')} required />
        {fieldErrors.name && <p className="text-xs text-red-500">{fieldErrors.name}</p>}
      </div>
      {/* Anti-bot honeypot — placed right after Full Name so it looks like a natural follow-up field to bots. Invisible to real users. */}
      <div
        aria-hidden="true"
        style={{
          position: 'absolute',
          opacity: 0,
          height: 0,
          width: 0,
          overflow: 'hidden',
          pointerEvents: 'none',
        }}
      >
        <label htmlFor="nickname-home">Nickname</label>
        <input
          id="nickname-home"
          type="text"
          name="Nickname"
          tabIndex={-1}
          autoComplete="off"
          required
          defaultValue=""
        />
      </div>
      <div className="space-y-2">
        <Label htmlFor="nric">New NRIC / Passport Number <span className="text-red-500">*</span></Label>
        <Input id="nric" value={formData.nric} onChange={(e) => handleInputChange('nric', e.target.value)} placeholder="Enter your NRIC/Passport number"
          aria-invalid={!!fieldErrors.nric} className={err('nric')} required />
        {fieldErrors.nric && <p className="text-xs text-red-500">{fieldErrors.nric}</p>}
      </div>
      <div className="space-y-2">
        <Label htmlFor="mobile">Mobile No. <span className="text-red-500">*</span></Label>
        <Input id="mobile" type="tel" value={formData.mobile}
          onChange={(e) => handleInputChange('mobile', e.target.value)}
          onBlur={(e) => validateField('mobile', e.target.value)}
          placeholder="Enter your mobile number"
          aria-invalid={!!fieldErrors.mobile} className={err('mobile')} required />
        {fieldErrors.mobile && <p className="text-xs text-red-500">{fieldErrors.mobile}</p>}
      </div>
      <div className="space-y-2">
        <Label htmlFor="email">Email Address <span className="text-red-500">*</span></Label>
        <Input id="email" type="email" value={formData.email}
          onChange={(e) => handleInputChange('email', e.target.value)}
          onBlur={(e) => validateField('email', e.target.value)}
          placeholder="Enter your email address"
          aria-invalid={!!fieldErrors.email} className={err('email')} required />
        {fieldErrors.email && <p className="text-xs text-red-500">{fieldErrors.email}</p>}
      </div>
      <div className="space-y-2">
        <Label htmlFor="address">Unifi Installation Address <span className="text-red-500">*</span></Label>
        <Textarea id="address" value={formData.address} onChange={(e) => handleInputChange('address', e.target.value)} placeholder="Enter your installation address" rows={3}
          aria-invalid={!!fieldErrors.address} className={err('address')} required />
        {fieldErrors.address && <p className="text-xs text-red-500">{fieldErrors.address}</p>}
      </div>
      <div className="space-y-2">
        <Label htmlFor="postcode">Postcode <span className="text-red-500">*</span></Label>
        <Input id="postcode" value={formData.postcode || ''} onChange={(e) => handleInputChange('postcode', e.target.value)} placeholder="Enter postcode"
          aria-invalid={!!fieldErrors.postcode} className={err('postcode')} required />
        {fieldErrors.postcode && <p className="text-xs text-red-500">{fieldErrors.postcode}</p>}
      </div>
      <div className="space-y-2">
        <Label htmlFor="installationDay">Preferred Installation Day <span className="text-red-500">*</span></Label>
        <Select onValueChange={(v) => handleInputChange('installationDay', v)} value={formData.installationDay}>
          <SelectTrigger data-field-error="installationDay" className={fieldErrors.installationDay ? 'border-red-500 focus:ring-red-500' : ''}>
            <SelectValue placeholder="Please Select" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="asap">As Soon As Possible</SelectItem>
            <SelectItem value="weekday">Weekday Only (Monday - Friday)</SelectItem>
            <SelectItem value="weekend">Weekend Only (Saturday - Sunday)</SelectItem>
          </SelectContent>
        </Select>
        {fieldErrors.installationDay && <p className="text-xs text-red-500">{fieldErrors.installationDay}</p>}
      </div>
    </>
  );
};
